import React, { useState } from "react";

// CSS-in-JS styles for GlobalDataTable
const styles = {
  tableWrap: {
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '0.5rem',
    border: '1px solid #e5e7eb',
    backgroundColor: 'white',
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    backgroundColor: 'white',
    margin: 0,
  },
  header: {
    backgroundColor: '#f9fafb',
    borderBottom: '1px solid #e5e7eb',
    textAlign: 'left',
    padding: '0.75rem 1rem',
    fontSize: '0.875rem',
    fontWeight: '600',
    color: '#374151',
    position: 'sticky',
    top: 0,
    zIndex: 10,
  },
  cell: {
    padding: '0.75rem 1rem',
    borderBottom: '1px solid #f3f4f6',
    fontSize: '0.875rem',
    color: '#1f2937',
    verticalAlign: 'middle',
    transition: 'background-color 0.15s ease-in-out',
  },
  row: {
    transition: 'background-color 0.15s ease-in-out',
  },
  rowHover: {
    backgroundColor: '#f9fafb',
  },
  actionsCell: {
    width: '1%',
    whiteSpace: 'nowrap',
    textAlign: 'right',
  }
};

// Enhanced table row component with hover effects
const TableRow = ({ children, onHover, ...props }) => {
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <tr
      style={{
        ...styles.row,
        ...(isHovered ? styles.rowHover : {})
      }}
      onMouseEnter={() => {
        setIsHovered(true);
        onHover?.();
      }}
      onMouseLeave={() => setIsHovered(false)}
      {...props}
    >
      {children}
    </tr>
  );
};

// Enhanced table cell component
const TableCell = ({ children, isActions = false, ...props }) => (
  <td
    style={{
      ...styles.cell,
      ...(isActions ? styles.actionsCell : {})
    }}
    {...props}
  >
    {children}
  </td>
);

export default function GlobalDataTable({
  headers = [],
  children,
  wrapClassName = "",
  tableClassName = "",
  tableAriaLabel = "Data table"
}) {
  return (
    <div style={{...styles.tableWrap}} className={wrapClassName}>
      <table 
        style={{...styles.table}} 
        className={tableClassName} 
        aria-label={tableAriaLabel}
      >
        <thead>
          <tr>
            {headers.map((h) => (
              <th 
                key={h.key || h.label} 
                scope="col" 
                style={{
                  ...styles.header,
                  ...(h.className?.includes('ub-table__col-actions') ? styles.actionsCell : {})
                }}
                className={h.className}
              >
                {h.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}

// Export enhanced components for advanced usage
export { TableRow, TableCell };

